export const refresh = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  await fetch(`${import.meta.env.VITE_AUTH_BACKEND_URL}/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${refreshToken}`,
    },
    body: JSON.stringify({
      clientId: import.meta.env.VITE_CLIENT_ID,
      scope: import.meta.env.VITE_REQUIRED_SCOPES.split(','),
      grant_type: 'refresh_token',
    }),
  })
    .then(async (response) => {
      const data = await response.json();
      if (data.accessToken && data.refreshToken) {
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);

        navigator.serviceWorker.ready.then((registration) => {
          registration.active.postMessage({
            type: 'token',
            token: localStorage.getItem('accessToken'),
          });
        });
      } else {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/organizer';
      }
    })
    .catch(() => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/organizer';
    });
};

export const getToken = async (authCode) => {
  const codeVerifier = localStorage.getItem('codeVerifier');
  await fetch(`${import.meta.env.VITE_AUTH_BACKEND_URL}/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      authCode,
      codeVerifier,
      clientId: import.meta.env.VITE_CLIENT_ID,
      scope: import.meta.env.VITE_REQUIRED_SCOPES.split(','),
    }),
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error("Couldn't get token");
    }
    const data = await response.json();
    // Clear local storage
    localStorage.removeItem('codeVerifier');
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);

    navigator.serviceWorker.ready.then((registration) => {
      registration.active.postMessage({
        type: 'token',
        token: localStorage.getItem('accessToken'),
      });
    });
  });
};
